import { gql, useQuery } from "@apollo/client";
import { getTranslatedString } from "helpers/utils-typescript";
import { SetStateAction, useMemo } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useSelector } from 'react-redux';
import { SustainableDevelopmentGoal } from "services/graphqltypes";

const LOAD_SDGS = gql`
query loadSdgs {
  sustainableDevelopmentGoals(orderBy: NUMBER_ASC) {
    nodes {
      id
      name
      number
    }
  }
}
`
/** A dropdown that is used to choose sdg to filter by. onClick it executes callback function with the selected sdg as argument. */
const SdgDropdownFilter = ({ setFilterBySdg, filterBySdg }: { setFilterBySdg: React.Dispatch<SetStateAction<SustainableDevelopmentGoal>>, filterBySdg: SustainableDevelopmentGoal }) => {
  const intl = useIntl();
  const currentLang = useSelector((langState: any) => langState.settings.locale);
  const allSdgs = { id: null, number: null } as unknown as SustainableDevelopmentGoal;

  /* */
  /* Query*/
  /* */
  const { loading, data } = useQuery(LOAD_SDGS)
  const sustainableDevelopmentGoals: SustainableDevelopmentGoal[] = useMemo(() => {
    if (loading || !data) {
      return [];
    }
    return data.sustainableDevelopmentGoals.nodes;
  }, [data, loading]);

  // handel filter change
  const handleChangeFilterBySdg = (sdg: SustainableDevelopmentGoal) => {
    setFilterBySdg(sdg);
    localStorage.setItem('filterBySdg', JSON.stringify(sdg));
  };

  // display text for selected Sdg

  const titleElement =
    <span className="dropdown-button-text-truncate">
      {filterBySdg?.number === null
        ? intl.formatMessage({ id: 'community.all-sdgs' })
        : getTranslatedString(filterBySdg?.name, currentLang)}
    </span>;

  return (
    <DropdownButton
      variant="outline-dark"
      id="filter-learning-path-button"
      className="filter-button"
      title={titleElement}
      size="xs">

      { /* "All SDGs" option*/}
      <Dropdown.Item onClick={() => handleChangeFilterBySdg(allSdgs)} className={filterBySdg.number === allSdgs.number && 'selected'}>
        {intl.formatMessage({ id: 'community.all-sdgs' })}
      </Dropdown.Item>
      {
        sustainableDevelopmentGoals.map((sdg, index) => {
          return (
            <div key={index}>
              <Dropdown.Item onClick={() => handleChangeFilterBySdg(sdg)} className={filterBySdg.number === sdg.number && 'selected'}>
                {`${sdg.number === null ? '' : `#${sdg.number}`}  ${getTranslatedString(sdg.name, currentLang)}`}
              </Dropdown.Item>
            </div>
          );
        })
      }
    </DropdownButton>
  );
};

export default SdgDropdownFilter;

